document.addEventListener("DOMContentLoaded", function(){
    const input     = document.getElementById('nf-image');
    const fileName  = document.getElementById('fileName');
    const preview   = document.getElementById('event-image');
    const error     = document.querySelector('.add-event__error-image-size');

    if( !input )
        return;

    input.addEventListener('change', function () {
        error.style.display = 'none';
        
        const file = this.files[0];

        if( !file )
            return;

        const maxSize = 2 * 1024 * 1024; // 2MB

        if( file.size > maxSize ) {
            this.value = '';
            fileName.textContent = '';
            preview.src = '';
            preview.style.display = 'none';
            error.style.display = 'flex';
            return;
        }

        // Show file name
        fileName.textContent = file.name;

        // Preview
        const reader = new FileReader();
        reader.onload = e => {
            preview.src = e.target.result;
            preview.style.display = 'block';
        };
        
        reader.readAsDataURL(file);
    });
});